<template>
  <div class="pdf-file">
    <div class="card" v-if="!printVisible">
      <div class="card-body">
        <div class="d-flex with-media">
          <div class="p-2 w-100">
            <div class="media">
              <img :src="examInfo.picture_path ? examInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
              <div class="media-body">
                <h5>{{examInfo.class_user_name}}</h5>
                <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-tabs ref="gradeTab" class="user-total-grade-tab" v-model="activeTabName">
      <el-tab-pane name="tab-total">
        <span slot="label" class="gray label">종합 성적표</span>
        <div class="print-grade-total">
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.book_name}}</h1>
                  <p></p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <strong><span class="card-grade-title">성적 분석</span></strong> <span class="card-grade-title-desc">내점수 / 배점 (백분위 점수)</span>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <!-- <th class="is-center stone-table-cell stone-table-label"></th> -->
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]" :title="examTotalTimesData[idx].exam_title">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <!-- <th class="is-center stone-table-cell stone-table-label">내점수 / 배점<br />(백분위 점수)</th> -->
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_score}}</strong> / {{examTotalTimesData[idx].quiz_score}}</div>
                                <div class="" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'">{{`(${examTotalTimesData[idx].exam_score_100})`}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <strong><span class="card-grade-title">석차 분석</span></strong> <span class="card-grade-title-desc">내석차 / 전체</span>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <!-- <th class="is-center stone-table-cell stone-table-label"></th> -->
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <!-- <th class="is-center stone-table-cell stone-table-label">석차 / 전체</th> -->
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_rank}}</strong> / {{examTotalTimesData[idx].entry_cnt}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
              </el-row>

               <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 변화 그래프</h2>
                      </div>
                      <div class="p-2 ml-auto chart-legend-title">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <line-chart :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
                  </fieldset>
                  <fieldset v-if="radarVisible">
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>영역별 누적 분석</h2>
                      </div>
                      <div class="p-2 ml-auto chart-legend-title">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <radar-chart :chart-data="radarTotalChartData" :height="radarChartHeight" :options="radarChartOptions" :styles="radarChartStyles"></radar-chart>
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>취약유형 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <colgroup>
                          <col width="15%" />
                          <col width="20%" />
                          <col width="65%" />
                        </colgroup>
                        <tr v-for="(quiz, idx) in quizWrongTotalData" :key="'tr_' + idx">
                          <td class="is-center stone-table-cell"><div class="cell">{{idx + 1}}</div></td>
                          <td class="is-center stone-table-cell"><div class="cell">{{quiz.group_name}}</div></td>
                          <td class="stone-table-cell"><div class="cell">{{quiz.cate_path}}</div></td>
                        </tr>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div class="print-grade-total">
          <div class="card second-card">
            <div class="card-body">
              <fieldset>
                <h2>선생님 의견</h2>
                <div v-html="replaceCarriageReturnToBr(examInfo.exam_times_comment)"></div>
              </fieldset>
            </div>
          </div>
        </div>
      </el-tab-pane> <!-- 종합성적표 end-->

    </el-tabs>

  </div>
</template>

<script>

import 'element-ui/lib/theme-chalk/display.css'
import common from '@/modules/common'
import grade from '@/modules/grade'

export default {
  name: 'R010203',
  mixins: [common.mixins, grade],
  props: {
    isPrint: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      printVisible: this.isPrint,
      examTotalTimesCount: 3,
      activeTabName: 'tab-total'
    }
  },
  mounted () {
    this.handleWindowResize()
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleWindowResize () {
      const clientWidth = this.$el.clientWidth
      if (clientWidth < 768) {
        this.examTotalTimesCount = 3
      } else if (clientWidth < 992) {
        this.examTotalTimesCount = 4
      } else if (clientWidth < 1200) {
        this.examTotalTimesCount = 5
      } else {
        this.examTotalTimesCount = 6
      }
      this.examTotalTimesSplitCount = this.getExamTotalTimesRows()
    },
    created () {
      if (this.$route.params) {
        this.param = {
          exam_seq: this.getToNumber(this.$route.params.exam_seq),
          class_seq: this.getToNumber(this.$route.params.class_seq),
          class_user_seq: this.getToNumber(this.$route.params.class_user_seq)
        }
        this.loadInfo()
        this.loadExamUserComment()
      }
    },
    initGradeTotal (params) {
      this.param = {
        exam_seq: this.getToNumber(params.exam_seq),
        class_seq: this.getToNumber(params.class_seq),
        class_user_seq: this.getToNumber(params.class_user_seq)
      }
      this.loadInfo()
      this.loadExamUserComment()
    },
    loadExamUserComment () {
      common.axios.post('/grade/exam/user/comment', this.param)
        .then(response => {
          const result = response.data
          this.examInfo.exam_comment = result.exam_comment
          this.examInfo.exam_times_comment = result.exam_times_comment
        })
    },
    // 시험 정보 조회
    loadInfo () {
      // 시험 정보
      common.axios.post('/grade/exam/user', this.param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
          // 모의고사인 경우에만 스파이더 차트를 보여준다
          if (result.exam_paper_type === 'TEST') {
            // 커리큘럼이 없을 경우에는 스파이더 차트 크기를 늘려준다.
            if (result.curriculum_yn === 'N') {
              this.lineVisible = false
              this.radarChartHeight = 442
            }
          } else {
            this.radarVisible = false
            if (result.curriculum_yn === 'Y') {
              const clientWidth = this.$el.clientWidth
              if (clientWidth < 768) {
                this.lineChartHeight = 200
              } else {
                this.lineChartHeight = 401
              }
            }
          }
          // 종합 성적표 조회(회차별)
          if (result.curriculum_yn === 'Y') {
            this.loadExamGradeTotalTimes()
          }
        })
    },
    getLineChartRankData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      value.map(x => {
        labels.push(x.times_name)
        datasets1.push(x.exam_rank)
        datasets2.push(x.entry_cnt)
      })
      const datasets = [
        {
          label: '내석차',
          // backgroundColor: '#00aec0',
          borderColor: '#00aec0',
          fill: false,
          radius: 4,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointBackgroundColor: '#00aec0',
          pointBorderColor: '#00aec0',
          pointHoverRadius: 5,
          data: datasets1
        }
      ]
      return {labels: labels, datasets: datasets, values: value}
    }
  }
}
</script>

<style>
  .user-total-grade-tab .el-tabs__header {
    display: none;
  }
</style>
<style scoped>
  .user-total-grade-tab .print-grade-total {
    padding: 0;
  }
  .user-total-grade-tab .el-tabs__content .user-table-times table tr td:first-child {
    background-color: white;
  }
  .chart-legend-title {
    padding-top: 24px !important;
  }
  .user-total-grade-tab .card-grade-title {
    font-size: 16px;
    line-height: 48px;
    margin-bottom: 0;
  }
  .user-total-grade-tab .card-grade-title-desc {
    color: #9898b8;
    font-size: 12px;
    line-height: 48px;
    margin-bottom: 0;
    margin-left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/R010203.vue